import { render, staticRenderFns } from "./InputCheckboxGroup.vue?vue&type=template&id=d6976106"
import script from "./InputCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports